import { render, staticRenderFns } from "./publicFooter.vue?vue&type=template&id=77231df2&scoped=true&"
import script from "./publicFooter.vue?vue&type=script&lang=js&"
export * from "./publicFooter.vue?vue&type=script&lang=js&"
import style0 from "./publicFooter.vue?vue&type=style&index=0&id=77231df2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77231df2",
  null
  
)

export default component.exports